var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page page-giftcode-index"},[_c('GiftcodesForYouPanel'),_c('b-row',[_c('div',{staticClass:"w-100"},[_c('hr')])]),_c('GamePickerPanel',{on:{"click":_vm.onGameClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }